import { NavigationContainer } from "@react-navigation/native";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { logoutUser } from "../actions/user";
import AuthScreens from "./auth";
import SecuredScreens from "./SecuredScreens";

function Screens({ loginData = {}, logout }) {
  useEffect(() => {
    let currentTime = parseInt(new Date().getTime() / 1000);
    if (loginData.expiry_time && currentTime > loginData.expiry_time) {
      logout();
    }
  }, []);

  return (
    <NavigationContainer>
      {loginData.access_token ? <SecuredScreens /> : <AuthScreens />}
    </NavigationContainer>
  );
}
const mapStateToProps = (state) => ({
  loginData: state.user.loginData,
});
const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logoutUser()),
});
export default connect(mapStateToProps, mapDispatchToProps)(Screens);
